<div fxLayout="row">
  <ng-container *ngIf="items | async as _items">
    <div *ngFor="let item of _items" fxLayout="row" fxLayoutAlign="start center">
      <a class="breadcrumbs-item" [routerLink]="item.routerLink">{{ item.label }}</a>
      <mat-icon color="primary">chevron_right</mat-icon>
    </div>
  </ng-container>
</div>
